import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLanguage,
  faLandmark,
  faScaleBalanced,
  faGraduationCap,
} from '@fortawesome/free-solid-svg-icons';
import icon from '../../../assets/icon.png';

export default () => {
  return (
    <div id="content">
      <div className="main logo">
        <img width="200" alt="icon" src={icon} />
      </div>
      <div className="main box">
        <div className="box-row">
          <Link to="/language">
            <button type="button">
              <FontAwesomeIcon icon={faLanguage} fontSize="50px" />
              <span>Georgian Language</span>
            </button>
          </Link>
          <Link to="/history">
            <button type="button">
              <FontAwesomeIcon icon={faLandmark} fontSize="50px" />
              History of Georgia
            </button>
          </Link>
        </div>
        <div className="box-row">
          <Link to="/law">
            <button type="button">
              <FontAwesomeIcon icon={faScaleBalanced} fontSize="50px" />
              Fundamentals of Law
            </button>
          </Link>
          <Link to="/simulate">
            <button className="btn-simulate" type="button">
              <FontAwesomeIcon icon={faGraduationCap} fontSize="50px" />
              Exam Simulation
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};
